<template>

<div>
    <div class="profile-header">
        <div class="jumbotron page-header d-flex justify-content-center align-items-center" 
                :style='{ "background-image" : "url("+ imgC.src +")" }'
                >
            <span class="white-coverage"></span>

            <span @click='openFileC' class="change-photo change-cover-photo d-flex align-items-center">
                <span class="icon icon-camera"></span>
                <span class="text">Корица</span>
            </span>

            <div class="inner-page-header text-center">
                <span @click='openFile' class="user-profile-pic mt-2 mb-3">
                    <span class="change-photo change-profile-photo">
                        <span class="icon icon-camera"></span>
                    </span>
                    <img v-if="userPic" :src="img.src" alt="User profile picture">
                    <span v-else class="icon icon-user"></span>
                </span>

                <h1 class="mb-0">Моят профил</h1>

                <div class="ratung d-flex justify-content-center text-align-center">
                    <div v-if='user.worker_rating' class="ml-2 mr-2">
                        <user-rating :rating='user.worker_rating'></user-rating>
                        <span class="number">Като изпълнител </span>
                    </div>
                    <div v-if='user.owner_rating' class="ml-2 mr-2">
                        <user-rating :rating='user.owner_rating'></user-rating>
                        <span class="number">Като възложител</span>
                    </div>
                </div>

                <!-- <div class="breadcrumbs">
                        <breadcrumbs></breadcrumbs>
                    </div> -->
                <div style='display: none'>
                    <img-field :model='img' :f='"src"' ref='img' :options='imageOptions'
                                    v-on:image-set='setImage'></img-field>  
                    <img-field :model='imgC' :f='"src"' ref='imgC' :options='imageOptionsCover'
                                    v-on:image-set='setImageCover()'></img-field>  
                </div>
            </div>
        </div>     
    </div>

    <div class="main-page-content">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-xl-8 col-lg-9 col-md-11">
                    <user-stats></user-stats>
                </div>
            </div>
                
       
            <div class="col-12">
                <div class="profile-navigation d-flex justify-content-center w-100">
                    <ul class="nav tab-nav mt-0 mb-4 mb-md-5">
                        <li class="nav-item">
                            <a @click='$parent.changePage("profile")' class="nav-link marker"> Лични данни </a>
                        </li>
                        <li class="nav-item">
                            <a @click='$parent.changePage("company-info")' class="nav-link marker"> Професионални данни </a>
                        </li>
                        <li class="nav-item">
                            <a @click='$parent.changePage("my-projects")' class="nav-link marker"> Моите проекти </a>
                        </li>
                        <li class="nav-item">
                            <a @click='$parent.changePage("part-projects")' class="nav-link marker"> Участие в проекти </a>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
                
            if( this.user.avatar ) {
                this.img.src = this.user.avatar;
            }

            if( this.user.cover ) {
                this.imgC.src = this.user.cover;
            }

        },

        data() {
            return {
                isReady : false,    
                marker  : '',
                item    : '',
                userPic : true,

                img : {
                    src : '/resources/images/defauit-list-user-img-big.jpg' //Deafault image
                },

                imgC : {
                    src : '/resources/images/page-header-bck.jpg' //Deafault image
                },

                imageOptions : {
                    id           : 'usr-prf',
                    width        : 240,
                    height       : 240,
                    maxFileSize  : 5000000,
                    allowedTypes : ['image/jpeg','image/png'],
                    textTitle    : 'Изображение',
                    wrapperClass : 'place-img-wrap',
                    imageClass   : "place-image",
                    // thumbnail    : 0.4
                },

                imageOptionsCover : {
                    id           : 'usr-cvr',
                    width        : 1920,
                    height       : 300,
                    maxFileSize  : 5000000,
                    allowedTypes : ['image/jpeg','image/png'],
                    textTitle    : 'Изображение',
                    wrapperClass : 'place-img-wrap',
                    imageClass   : "place-image",
                    // thumbnail    : 0.4
                },

            }
        },

        methods : {
            // indicator(e) {
            //     this.marker.style.left = e.offsetLeft + e.offsetWidth / 4 + "px";
            //     this.marker.style.width = e.offsetWidth / 2 + "px";
            // },

            openFile() {
                $("#usr-prf-fs").click();
            },

            openFileC() {
                $("#usr-cvr-fs").click();
            },

            setImage() {

                var me = this;

                me.ajax.call('usr:sva', this.img, (r) => {
                    
                    if( r.status == 'success' ) {
                        $.notify("Вашият аватар беше обновен","success");
                    }

                })
            },

            setImageCover() {

                var me = this;

                me.ajax.call('usr:svc', this.imgC, (r) => {
                    
                    if( r.status == 'success' ) {
                        $.notify("Вашият кавър беше обновен","success");
                    }

                })
            }
        }

    }
</script>
